import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicalFeePaymentManualWizardComponent } from './medical-fee-payment-manual-wizard.component';
import { SharedModule } from '../../shared.module';
import { SharedMaterialModule } from '../../shared-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MedicalFeeAmountComponent } from '../../controls/medical-fee/medical-fee-amount/medical-fee-amount.component';
import { MedicalFeeWithholdTaxDialogComponent } from '../../dialogs/medical-fee-withhold-tax-dialog/medical-fee-withhold-tax-dialog.component';
import { MedicalFeeTaxAmountDialogComponent } from '../../dialogs/medical-fee-tax-amount-dialog/medical-fee-tax-amount-dialog.component';
import { MedicalFeeReportDialogComponent } from '../../dialogs/medical-fee-report-dialog/medical-fee-report-dialog.component';
import { MedicalFeePaymentManualAmountComponent } from '../medical-fee-payment-manual-amount/medical-fee-payment-manual-amount.component';

@NgModule({
  declarations: [
    MedicalFeePaymentManualWizardComponent,
    MedicalFeePaymentManualAmountComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedMaterialModule,
    ReactiveFormsModule,
  ]
})
export class MedicalFeePaymentManualWizardModule { }
